import { useDispatch, useSelector } from "react-redux";
import SelectDefault from "@/src/components/SelectDefault/SelectDefault";
import { officeAccountingHeaderSelectConst } from "@/src/constants/officeAccountingTableConfig";
import { setActualOfficeTable } from "@/src/store/slices/OfficeAccountingPage/officeAccountingFiltersSlice";
import { RootState } from "@/src/store";

const HeaderOfficeAccounting = () => {
  const dispatch = useDispatch();
  const hasFullCountryAccess = useSelector((state: RootState) => state.accessControl.hasFullCountryAccess);
  const actualOfficeTable = useSelector((state: RootState) => state.officeAccountingFilters.actualOfficeTable);
  const isOfficeSelectDisabled = !hasFullCountryAccess;

  const handleOfficeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (isOfficeSelectDisabled) return;
    dispatch(setActualOfficeTable(event.target.value));
  };

  return (
    <div className={`header-office-accounting ${isOfficeSelectDisabled ? "disabled" : ""}`}>
      <SelectDefault
        onChange={handleOfficeChange}
        value={actualOfficeTable || "ALL"}
        disabled={isOfficeSelectDisabled}
      >
        {officeAccountingHeaderSelectConst.map((item) => (
          <option value={item.id} key={item.id}>
            {item.title}
          </option>
        ))}
      </SelectDefault>
    </div>
  );
};

export default HeaderOfficeAccounting;
